import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';
import { TokenExpired } from '@app/store/auth/auth.actions';
import { AppState } from '@app/store/app.reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class MyAgentsRouteGuard  {

    constructor(private auth: AuthService, private router: Router, private store: Store<AppState>) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this.auth.isAuthenticated()) {
            this.store.dispatch(new TokenExpired(state.url));
            return false;
        }
        return true;
    }
}
